module.exports = __webpack_public_path__ + "img/a-01.181f7438.png";